/**
 * Frontend mirror of OpenTalents.Domain.Entities.Subscriptions.EntitlementKeys
 * Keep in sync with the backend constant class.
 *
 * @userstory US-ENT-01, US-ENT-02, US-ENT-03
 */
export const EntitlementKeys = {
	Capabilities: {
		PremiumModel: 'org.premium_model',
		PdfExport: 'org.pdf_export',
		Analytics: 'org.analytics',
		NewProfileNotifications: 'org.new_profile_notifications',
		PrioritySupport: 'org.priority_support',
		AtsIntegration: 'org.ats_integration',
		InsightsSegmented: 'org.insights_segmented',
		InsightsTrends: 'org.insights_trends',
		InsightsExport: 'org.insights_export',
		InsightsRecruitability: 'org.insights_recruitability',
		InsightsRates: 'org.insights_rates',
		InsightsEmerging: 'org.insights_emerging',
		InsightsPeerDemand: 'org.insights_peer_demand',
		InsightsSelfBenchmark: 'org.insights_self_benchmark',
	},
	Quotas: {
		ChatsPerMonth: 'org.chats_per_month',
		PublicNeedsActive: 'org.public_needs_active',
		Seats: 'org.seats',
		InsightsExportsPerDay: 'org.insights_exports_per_day',
	},
	AddOns: {
		ChatExtra: 'addon.chat_extra',
		FreelanceManagement: 'addon.freelance_management',
	},
	TalentCapabilities: {
		VideoPitch: 'talent.video_pitch',
		StakeholderMessages: 'talent.stakeholder_messages',
		MarketInsights: 'talent.market_insights',
		DreamTeam: 'talent.dream_team',
		ProfilePresentationBoost: 'talent.profile_presentation_boost',
	},
} as const;
